import React from 'react';
import { Link } from 'react-router-dom';

function MenuShop(props) {
    let divider = props.divider
    let marginLeft = {paddingLeft:"15px"} 
    if (props.border === false ){
        marginLeft = { paddingLeft:"0" }
    }else{
        marginLeft = {paddingLeft:"15px"} 
    }
    return (
        <div className={props.tipomenu}>
            <Link className="dropdown-item" style={marginLeft} to="/orders">ORDINI</Link>
            <Link className="dropdown-item" style={marginLeft} to="/profile">I MIEI DATI</Link> 
            <Link className="dropdown-item" style={marginLeft} to="/cart">CARRELLO</Link>
            {props.divider ? <div className="dropdown-divider"></div> : null}
            <Link className="dropdown-item" style={marginLeft} to="/logout">ESCI</Link>
        </div>
    );
}

export default MenuShop;